"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var _react = _interopRequireDefault(require("react"));
var _reactI18next = require("react-i18next");
var _propTypes = _interopRequireDefault(require("prop-types"));
var _cssClassesHelper = require("../../../../helpers/cssClassesHelper");
require("./BuySellMakeTransactionComponent.css");
function _interopRequireDefault(e) { return e && e.__esModule ? e : { "default": e }; }
var classes = (0, _cssClassesHelper.getBEMClasses)('buy-sell-make-transaction');
var BuySellMakeTransaction = function BuySellMakeTransaction(props) {
  var _useTranslation = (0, _reactI18next.useTranslation)("core"),
    t = _useTranslation.t;
  return /*#__PURE__*/_react["default"].createElement("div", {
    className: classes(null, props.themeModifier)
  }, /*#__PURE__*/_react["default"].createElement("h2", {
    className: classes('title', props.themeModifier)
  }, t("Make a Transaction")), /*#__PURE__*/_react["default"].createElement("div", {
    className: classes('content', props.themeModifier)
  }, props.children));
};
BuySellMakeTransaction.propTypes = {
  displayInstrumentSelector: _propTypes["default"].bool,
  extraInfoComponent: _propTypes["default"].element,
  themeModifier: _propTypes["default"].string
};
var _default = exports["default"] = BuySellMakeTransaction;